<template>
  <div></div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'account',
  computed: {
    ...mapGetters('user', [
      'currentUserID'
    ])
  },
  mounted () {
    this.$router.push('/admin/users/' + this.currentUserID);
  }
}
</script>
